<form [formGroup]="userRequestForm" (ngSubmit)="saveForm(userRequestForm.value)" autocomplete="off">
  <div class="ui-grid ui-grid-responsive ui-fluid user-request-content">
    <div class="ui-g-12" *ngIf="organisationSubType == 1 || organisationSubType == 4">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="firstName">First Name </label><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input pInputText id="firstName" formControlName="firstName" />
      </div>
    </div>
    <div class="ui-g-12" *ngIf="organisationSubType == 1 || organisationSubType == 4">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="surname">Surname </label><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12"><input pInputText id="surname" formControlName="surname" /></div>
    </div>
    <div class="ui-g-12" *ngIf="organisationSubType == 1 || organisationSubType == 4">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="dateOfBirth">Date Of Birth</label><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input
          pInputText
          required="true"
          type="date"
          formControlName="dateOfBirth"
          name="dateOfBirth"
        />
      </div>
    </div>
    <div class="ui-g-12" *ngIf="organisationSubType == 1 || organisationSubType == 4">
      <div class="ui-g-12 label-content">
        <h2>Home Address</h2>
      </div>
    </div>
    <div
      class="ui-g-12"
      *ngIf="
        organisationSubType == 2 ||
        organisationSubType == 3 ||
        organisationSubType == 5 ||
        organisationSubType == 6
      "
    >
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="companyName">Company Name </label><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input pInputText id="companyName" formControlName="companyName" />
      </div>
    </div>
    <div
      class="ui-g-12 label-content"
      *ngIf="
        organisationSubType == 2 ||
        organisationSubType == 3 ||
        organisationSubType == 5 ||
        organisationSubType == 6
      "
    >
      <div class="ui-g-12 label-content">
        <h2>Registered Address</h2>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="addressLine1">Address Line 1 </label><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input pInputText id="addressLine1" formControlName="addressLine1" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="addressLine2">Address Line 2</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input pInputText id="addressLine2" formControlName="addressLine2" autocomplete="off" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="addressLine3">Address Line 3</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input pInputText id="addressLine3" formControlName="addressLine3" autocomplete="off" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="town">Town </label><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input pInputText id="town" formControlName="town" autocomplete="off" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="postcode">Postcode </label><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input pInputText id="postcode" formControlName="postcode" autocomplete="off" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="phoneNumber" *ngIf="organisationSubType == 1 || organisationSubType == 4"
          >Mobile Number</label
        >
        <label
          for="phoneNumber"
          *ngIf="
            organisationSubType == 2 ||
            organisationSubType == 3 ||
            organisationSubType == 5 ||
            organisationSubType == 6
          "
          >Telephone Number</label
        ><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <div class="ui-grid-col-2">
          <label>+44</label>
        </div>
        <div class="ui-grid-col-10">
          <input
            pInputText
            type="tel"
            id="phoneNumber"
            formControlName="phoneNumber"
            [ngModel]="phoneNumber"
          />
        </div>
      </div>
    </div>

    <div class="ui-g-12" *ngIf="organisationSubType == 1">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="driverLicence">Driving Licence Number <label class="Required">*</label></label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input
          pInputText
          id="driverLicence"
          formControlName="driverLicence"
          class="driverLicence"
        />
      </div>
    </div>

    <div class="ui-g-12" *ngIf="organisationSubType == 2 || organisationSubType == 3">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="surname">Company Registration Number</label><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input
          pInputText
          id="companyRegistrationNumber"
          formControlName="companyRegistrationNumber"
        />
      </div>
    </div>
    <div class="ui-g-12" *ngIf="organisationSubType == 2 || organisationSubType == 3">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="vatNumberCheck">Are you Registered for VAT ? </label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <p-checkbox
          formControlName="vatRegisterCheck"
          (onChange)="handleVATStatusChange($event)"
        ></p-checkbox>
      </div>
      <p style="clear: both"></p>
      <div *ngIf="vatRegisterCheck">
        <div class="ui-g-4 ui-sm-12 label-content">
          <label for="vatNumber">VAT Number </label><label class="Required">*</label>
        </div>
        <div class="ui-g-8 ui-sm-12">
          <input pInputText id="vatNumber" formControlName="vatNumber" />
        </div>
      </div>
    </div>
    <div class="ui-g-12" *ngIf="organisationSubType == 2 || organisationSubType == 3">
      <div class="ui-g-4 ui-sm-12 label-content"><label for="website">Website</label></div>
      <div class="ui-g-8 ui-sm-12"><input pInputText id="website" formControlName="website" /></div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4 ui-sm-12 label-content">
        <label for="emailAddress">Email Address </label><label class="Required">*</label>
      </div>
      <div class="ui-g-8 ui-sm-12">
        <input pInputText id="emailAddress" formControlName="emailAddress" />
      </div>
    </div>
  </div>
  <div>
    <button
      type="button"
      (click)="Clear()"
      pButton
      icon="fa ui-icon-close"
      label="Clear"
      class="ui-button btn-to-right"
    ></button>
    <button
      type="submit"
      pButton
      icon="fa ui-icon-check"
      label="Register"
      class="green-btn btn-to-right"
    ></button>
  </div>
</form>
<div
  style="
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: gray;
    opacity: 0.3;
  "
  *ngIf="isBusy"
>
  <img
    src="assets/images/loader.gif"
    style="margin-left: 45%; margin-top: 10%"
    width="50"
    height="50"
    alt="load"
  />
</div>
